



































import {Component, Prop, Vue} from "vue-property-decorator";
import QTableHeader from "@/common/qTableHeader.vue";
import User from "@/model/user";
import store from "@/store";
@Component({
  name: "getAdminList",
  components: {
    QTableHeader,
  },
})
export default class getUserList extends Vue {
  @Prop({
    default: () => {
      return [];
    },
  })
  users: User[];

  public headers = [
    { id: "id", name: "ID" },
    { id: "username", name: "ユーザー名" , order: "asc" },
    { id: "email", name: "MAIL", order: "asc" },
    { id: "cooperate_count", name: "連携数" },
    { id: "", name: "" },
  ];

  public onShowUserInfor(user) {
    store.dispatch("User/setUser", user);
    this.$emit('userInfo');
  }
}
